<template>
  <div class="tabs-gallery">
    <tabs :options="{ useUrlFragment: false }">
      <tab :name="$t('Image Gallery')">
        <appImageEditorLocalImages />
      </tab>
      <tab :name="$t('Own Images')">
        <appImageEditorUploadedImages />
      </tab>
    </tabs>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { Tabs, Tab } from "vue3-tabs-component";

import ImageEditorLocalImages from "../imageEditorGalleries/ImageEditorLocalImages";
import ImageEditorUploadedImages from "../imageEditorGalleries/ImageEditorUploadedImages";

export default {
  components: {
    tabs: Tabs,
    tab: Tab,
    appImageEditorLocalImages: ImageEditorLocalImages,
    appImageEditorUploadedImages: ImageEditorUploadedImages
  },
  computed: {}
};
</script>
